import styled from '@emotion/styled';
import { Paper, Typography } from '@material-ui/core';
import { ChangeEvent, ClassAttributes, createElement } from 'react';
import { FormattedMessage } from 'react-intl';

import Language, { AVAILABLE_LANGUAGES } from '../../entity/Language';
import Select, { SelectItem } from '../component/compound/Select';
import LanguageComponent from '../component/primitive/Language';
import _Breadcrumbs from '../connected/Breadcrumbs';
import { SPACING_REGULAR, SPACING_UNIT } from '../constant/spacing';

type Props = ClassAttributes<HTMLElement> & {
  language: Language;
  onChangeLanguage: (e: ChangeEvent<HTMLElement>, language: Language) => void;
  className?: string;
};

const ConfigurationPage = ({ language, onChangeLanguage, className }: Props) => (
  <Root className={className}>
    <Breadcrumbs />

    <PageHeading variant="h4" color="primary" noWrap>
      <FormattedMessage id="configuration_page.page_heading" />
    </PageHeading>

    <LanguageHeading variant="h5" color="textSecondary">
      <FormattedMessage id="configuration_page.language_heading" />
    </LanguageHeading>

    <Language>
      <LanguageSelect
        label={<FormattedMessage id="configuration_page.language_heading" />}
        defaultValue={language}
        onChange={onChangeLanguage as any}
      >
        {AVAILABLE_LANGUAGES.map((language) => (
          <SelectItem value={language} key={language}>
            <LanguageComponent language={language} />
          </SelectItem>
        ))}
      </LanguageSelect>
    </Language>
  </Root>
);

const Root = styled('div')({
  padding: `${SPACING_UNIT * 10}px calc((100% - 960px) / 2)`,
});

const Breadcrumbs = styled(_Breadcrumbs)({ marginBottom: SPACING_UNIT * 5 });

const PageHeading = styled(Typography)({ marginBottom: SPACING_UNIT * 5 });

const LanguageHeading = styled(Typography)({ marginBottom: SPACING_UNIT * 3 });

const Language = styled(Paper)({
  padding: SPACING_REGULAR,
});

const LanguageSelect = styled(Select)({ width: 192 });

export default ConfigurationPage;
